<template>
  <div class="menu">
    <div class="menu-user">
      <div><img :src="imgPath" onerror="this.src='/public/image/patient.png';this.onerror=null;" /></div>
      <div>{{store.account.name}}</div>
    </div>
    <div class="menu-content">
      <router-link :to="{name:'homepage'}"><div>首页</div></router-link>
      <router-link :to="{name:'caselist'}"><div>档案</div></router-link>
      <router-link :to="{name:'evaluation'}"><div>测评</div></router-link>
      <router-link :to="{name:'train'}"><div>训练体验</div></router-link>
      <router-link :to="{name:'orderList'}"><div>居家康复</div></router-link>
    </div>
    <div class="menu-footer">
      <li class="version" style="color:#999;font-weight:400;margin-bottom:20px;">
        <img style="position:absolute;bottom:200px;width:147px;height:144px;" src="../../../assets/img/WeChat.png" v-show="weChat">
        <a href="http://www.66nao.com/" target="_blanck" style="line-height: 24px;">进入官网</a>
        <button v-on:mouseover='showWeChat'  v-on:mouseout='hideWeChat'>联系我们</button>
      </li>
      <div @click="seeLog"  class="see-log">Version:{{showVersion}}</div>
      <div class="foot-flag">2019<img src="../../../assets/img/logo_gray.png"/><span v-html="gName"></span></div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

  export default({
    data () {
      return {
        gName: GLOBAL.NAME,
        store: require('../../../app/store.js'),
        //version: require('../../../../build/version.json'),
        // version: VERSION,
        version: g_system_preferences.version,
        weChat:false,
      }
    },
    methods:{
      hideWeChat:function(){
        this.weChat = false
      },
      showWeChat:function(){
        this.weChat = true
      },
      seeLog(){
        window.open('/#/seelog');
      },
    },
    computed:{
      showVersion: function(){
        if (undefined !== window.g_injected_version)
        {
          return window.g_injected_version;
        }
        return this.version;
        /*
        if(this.version.version){
          return this.version.version;
        } else {
          var date = new Date(this.version.date);
          var Y = date.getFullYear().toString().substr(2,2);
          var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
          var D = (date.getDate() < 10 ? '0'+(date.getDate()): date.getDate());
          var h = date.getHours().toString().substring(0,2);
          return Y+M+D+h;
        }
        */
      },
      imgPath: function(){
        var k = Math.random();
        var v = Math.random();
        return GLOBAL.lan_cognition +'/'+ this.store.account.path+'?' + k + '=' + v;
      }
    },
  })
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import "../../../assets/css/app.styl";
  @import "../../../assets/css/variable.styl";

  .menu
    position fixed
    top 64px
    width $left-menu-width
    height calc(100% - 64px)
    display flex
    flex-direction column
    align-items center
    justify-content space-between
    border-right 1px solid #dedede
    text-align center
    .menu-user
      flex-grow 1
      margin-top 44px
      img
        border-radius 50%
        width 80px
        height 80px
        margin-bottom 17px
    .menu-content
      flex-grow 5
      font-weight bold
      div
        width $left-menu-width
        height $menu-height
        line-height $menu-height
      :hover
        color $color-font-primary
        background-color $base-bgcolor
      :active
        color $color-font-primary
        background-color $base-bgcolor
    .menu-footer
      position relative
      margin-bottom 25px
      flex-grow 1
      color #aaa
      img
        height 25px
    .foot-flag
      display flex
      margin-left 20px
      align-items center
    .see-log:hover
      cursor pointer
      text-decoration underline

</style>
<style>
.version{
  width:100%;
  display: flex;
  align-items: center;
  justify-content:flex-end;
  flex-direction: column;
}

@media (-webkit-max-height: 750px) ,(max-height:750px) {
  .version{
    display: none;
  }
}

.version button,.version a {
  font-family: PingFangTC-Regular;
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  line-height: 12px;
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-radius: 140px;
  display: inline-block;
  height:24px;
  width:120px;
  margin-top:15px;
}

.big-tm {
  font-size: 1.5rem;
  text-shadow: #ccc;
  color: #222;
}
</style>



// WEBPACK FOOTER //
// leftmenu.vue?5341526a